export default __webpack_public_path__ + "static/media/test_kinosnacks_fuer kinoprogramm_geliefert_zum_auto.9d801c6f.jpg";